/* Bellani Pets cart: AJAX add to cart, cart drawer, cart page enhancement.
 * Plain ES2019, no dependencies. Loaded with defer from layout/bellani.liquid.
 * Public API: window.BP.cart.{open, close, toggle, isOpen, refresh, getCart, change, add}
 * Events (on document): bp:cart:updated (detail: cart JSON), bp:cart:open, bp:cart:close,
 *                       bp:cart:error (detail: { message, source })
 */
(function () {
  'use strict';

  var BP = (window.BP = window.BP || {});
  if (BP.cart && BP.cart.__ready) return;

  var DRAWER_SECTION = 'bp-cart-drawer';
  var DEBOUNCE_MS = 350;

  /* ---------- routes ---------- */
  function routes() {
    var s = (window.BP_SETTINGS && window.BP_SETTINGS.routes) || {};
    var root = s.root || s.root_url || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return {
      root: root,
      add: s.cart_add_url || root + 'cart/add',
      change: s.cart_change_url || root + 'cart/change',
      update: s.cart_update_url || root + 'cart/update',
      cart: s.cart_url || root + 'cart'
    };
  }

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  function drawerRoot() { return qs('[data-bp-cart-drawer]'); }
  function drawerPanel() { return document.getElementById('bp-cart-drawer'); }
  function mainCart() { return qs('[data-bp-main-cart]'); }

  function sectionIds() {
    var ids = [];
    if (drawerRoot()) ids.push(DRAWER_SECTION);
    var main = mainCart();
    if (main && main.getAttribute('data-section-id')) ids.push(main.getAttribute('data-section-id'));
    return ids;
  }

  function parseJSON(res) {
    return res.text().then(function (text) {
      var data = null;
      try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
      if (!res.ok) {
        var msg = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
        if (typeof msg !== 'string') msg = 'Something went wrong. Please try again.';
        var err = new Error(msg);
        err.status = res.status;
        err.data = data;
        throw err;
      }
      return data;
    });
  }

  function getCart() {
    return fetch(routes().root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(parseJSON);
  }

  function fetchSections(ids) {
    if (!ids.length) return Promise.resolve({});
    var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseJSON)
      .catch(function () { return {}; });
  }

  function formatMoney(cents, currency) {
    if (typeof BP.formatMoney === 'function' && BP.formatMoney !== formatMoney) {
      try { return BP.formatMoney(cents); } catch (e) { /* fall through */ }
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) { /* fall through */ }
    }
    var cur = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function announce(text) {
    qsa('[data-bp-cart-status]').forEach(function (el) {
      el.textContent = '';
      window.setTimeout(function () { el.textContent = text; }, 60);
    });
  }

  /* ---------- rendering ---------- */
  function updateCounts(cart) {
    var count = cart ? cart.item_count : 0;
    qsa('[data-bp-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.setAttribute('data-count', String(count));
      if (count > 0) el.removeAttribute('data-empty');
      else el.setAttribute('data-empty', '');
      if (el.hasAttribute('data-hide-empty')) el.hidden = count === 0;
    });
  }

  function updateSyncedShippingBars(cart) {
    qsa('[data-bp-free-shipping-sync]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 10000;
      var total = cart ? cart.total_price : 0;
      var remaining = threshold - total;
      var pct = remaining <= 0 ? 100 : Math.max(0, Math.floor((total * 100) / threshold));
      var text = qs('[data-bp-free-shipping-text]', bar);
      var fill = qs('[data-bp-free-shipping-fill]', bar);
      if (text) text.textContent = remaining <= 0 ? 'You get free US shipping' : 'Add ' + formatMoney(remaining, cart && cart.currency) + ' more for free US shipping';
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('is-complete', remaining <= 0);
    });
  }

  /* Remember focus so it survives an innerHTML swap. */
  function captureFocus() {
    var el = document.activeElement;
    if (!el || el === document.body) return null;
    var line = el.closest('[data-bp-line]');
    return {
      id: el.id || null,
      step: el.getAttribute('data-bp-qty-step'),
      remove: el.hasAttribute('data-bp-remove'),
      line: line ? line.getAttribute('data-bp-line') : null,
      inDrawer: !!el.closest('#bp-cart-drawer'),
      inMain: !!el.closest('[data-bp-main-cart]')
    };
  }

  function restoreFocus(info) {
    if (!info) return;
    var scope = info.inDrawer ? drawerPanel() : info.inMain ? mainCart() : null;
    if (!scope || scope.contains(document.activeElement)) return;
    var target = null;
    if (info.id) target = document.getElementById(info.id);
    if (!target && info.line) {
      var li = qs('li[data-bp-line="' + info.line + '"]', scope);
      if (li) {
        if (info.step) target = qs('[data-bp-qty-step="' + info.step + '"]', li);
        if (!target) target = qs('[data-bp-qty-input]', li);
      }
    }
    if (!target) {
      target = info.inDrawer
        ? qs('[data-bp-qty-input], .bp-cart-empty a, [data-bp-cart-close]', scope)
        : qs('h1', scope);
      if (target && target.tagName === 'H1') target.setAttribute('tabindex', '-1');
    }
    if (target) target.focus();
  }

  function renderSections(sections) {
    if (!sections) return;
    var focus = captureFocus();
    var parser = new DOMParser();

    if (sections[DRAWER_SECTION]) {
      var doc = parser.parseFromString(sections[DRAWER_SECTION], 'text/html');
      var newInner = qs('[data-bp-cart-drawer-inner]', doc);
      var curInner = qs('[data-bp-cart-drawer-inner]');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
      var newCount = qs('[data-bp-cart-drawer-count]', doc);
      var curCount = qs('[data-bp-cart-drawer-count]');
      if (newCount && curCount) curCount.innerHTML = newCount.innerHTML;
    }

    var main = mainCart();
    if (main) {
      var id = main.getAttribute('data-section-id');
      if (id && sections[id]) {
        var mdoc = parser.parseFromString(sections[id], 'text/html');
        var newMain = qs('[data-bp-main-cart]', mdoc);
        if (newMain) main.innerHTML = newMain.innerHTML;
      }
    }

    restoreFocus(focus);
  }

  function applyCart(cart, sections) {
    var p = sections ? Promise.resolve(sections) : fetchSections(sectionIds());
    return p.then(function (s) {
      renderSections(s);
      updateCounts(cart);
      updateSyncedShippingBars(cart);
      emit('bp:cart:updated', cart);
      return cart;
    });
  }

  function refresh() {
    return getCart().then(function (cart) { return applyCart(cart); });
  }

  /* ---------- request queue (keeps change calls in order) ---------- */
  var queue = Promise.resolve();
  function enqueue(fn) {
    var next = queue.then(fn, fn);
    queue = next.catch(function () {});
    return next;
  }

  function setBusy(on) {
    var d = drawerRoot();
    if (d) d.setAttribute('aria-busy', on ? 'true' : 'false');
    var m = mainCart();
    if (m) m.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* ---------- add to cart ---------- */
  function add(formData) {
    var r = routes();
    var ids = sectionIds();
    if (ids.length) {
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(r.add + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(parseJSON)
      .then(function (item) {
        var sections = item && item.sections ? item.sections : null;
        return getCart().then(function (cart) {
          return applyCart(cart, sections).then(function () { return { item: item, cart: cart }; });
        });
      });
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.hasAttribute('data-bp-add-to-cart')) return;
    if (!window.fetch || !window.FormData) return; // let the browser post normally
    event.preventDefault();

    var button = event.submitter || qs('[type="submit"], button:not([type])', form);
    if (button && button.getAttribute('aria-busy') === 'true') return;
    var errorEl = qs('[data-bp-form-error]', form);
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }

    var opener = button || form;
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

    add(fd)
      .then(function (res) {
        var item = res.item || {};
        var title = item.product_title || item.title || 'Item';
        open(opener);
        announce(title + ' added to cart');
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : 'Something went wrong. Please try again.';
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
        else announce(msg);
        emit('bp:cart:error', { message: msg, source: form });
      })
      .then(function () {
        if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
      });
  }

  /* ---------- change line quantity ---------- */
  function change(line, quantity) {
    var r = routes();
    var ids = sectionIds();
    setBusy(true);
    return enqueue(function () {
      return fetch(r.change + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: ids.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(parseJSON)
        .then(function (cart) {
          return applyCart(cart, cart && cart.sections ? cart.sections : null);
        });
    }).then(
      function (cart) {
        setBusy(false);
        announce(quantity === 0 ? 'Item removed. Cart updated.' : 'Cart updated');
        return cart;
      },
      function (err) {
        setBusy(false);
        var msg = err && err.message ? err.message : 'Something went wrong. Please try again.';
        showLineError(line, msg);
        emit('bp:cart:error', { message: msg, source: 'change' });
        // Re-sync UI with the real cart after a failed change.
        refresh().catch(function () {}).then(function () { showLineError(line, msg); });
        throw err;
      }
    );
  }

  function showLineError(line, msg) {
    var shown = false;
    qsa('li[data-bp-line="' + line + '"] [data-bp-line-error]').forEach(function (el) {
      el.textContent = msg;
      el.hidden = false;
      shown = true;
    });
    if (!shown) {
      qsa('[data-bp-cart-error]').forEach(function (el) { el.textContent = msg; el.hidden = false; });
    }
    announce(msg);
  }

  var timers = {};
  function scheduleChange(line, quantity) {
    window.clearTimeout(timers[line]);
    timers[line] = window.setTimeout(function () {
      delete timers[line];
      change(line, quantity).catch(function () {});
    }, DEBOUNCE_MS);
  }

  function flushChange(line, quantity) {
    window.clearTimeout(timers[line]);
    delete timers[line];
    change(line, quantity).catch(function () {});
  }

  function lineInputs(line) {
    return qsa('li[data-bp-line="' + line + '"] [data-bp-qty-input]');
  }

  function onClick(event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var toggle = t.closest('[data-bp-cart-toggle]');
    if (toggle && drawerRoot()) {
      event.preventDefault();
      toggleDrawer(toggle);
      return;
    }

    var closeBtn = t.closest('[data-bp-cart-close]');
    if (closeBtn && drawerRoot() && drawerRoot().contains(closeBtn)) {
      event.preventDefault();
      close();
      return;
    }

    if (!window.fetch) return;

    var step = t.closest('[data-bp-qty-step]');
    if (step) {
      var li = step.closest('li[data-bp-line]');
      if (!li) return;
      event.preventDefault();
      var line = parseInt(li.getAttribute('data-bp-line'), 10);
      var input = qs('[data-bp-qty-input]', li);
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      var next = Math.max(0, current + parseInt(step.getAttribute('data-bp-qty-step'), 10));
      lineInputs(line).forEach(function (i) { i.value = String(next); });
      clearLineError(li);
      if (next === 0) flushChange(line, 0);
      else scheduleChange(line, next);
      return;
    }

    var remove = t.closest('[data-bp-remove]');
    if (remove) {
      var rli = remove.closest('li[data-bp-line]');
      if (!rli) return;
      event.preventDefault();
      flushChange(parseInt(rli.getAttribute('data-bp-line'), 10), 0);
    }
  }

  function clearLineError(li) {
    var e = qs('[data-bp-line-error]', li);
    if (e) { e.textContent = ''; e.hidden = true; }
  }

  function onQtyInput(input, immediate) {
    var li = input.closest('li[data-bp-line]');
    if (!li) return;
    var line = parseInt(li.getAttribute('data-bp-line'), 10);
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    input.value = String(value);
    clearLineError(li);
    if (immediate) flushChange(line, value);
    else scheduleChange(line, value);
  }

  function onChange(event) {
    var t = event.target;
    if (!t || !window.fetch) return;
    if (t.matches && t.matches('[data-bp-qty-input]')) {
      onQtyInput(t, false);
      return;
    }
    if (t.matches && t.matches('[data-bp-cart-note]')) saveNote(t.value);
  }

  var noteTimer;
  function saveNote(note) {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(routes().update + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      }).catch(function () {});
    }, 200);
  }

  function onKeydownGlobal(event) {
    var t = event.target;
    // Enter in a quantity field updates that line instead of submitting checkout.
    if (event.key === 'Enter' && t && t.matches && t.matches('[data-bp-qty-input]') && window.fetch) {
      event.preventDefault();
      onQtyInput(t, true);
    }
  }

  /* ---------- drawer open / close ---------- */
  var lastOpener = null;
  var releaseTrap = null;
  var closeTimer = null;

  function focusables(container) {
    return qsa(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) {
      return !el.hidden && el.offsetParent !== null && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  function ownTrap(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = focusables(container);
      if (!items.length) { e.preventDefault(); container.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === container)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    document.addEventListener('keydown', onKey);
    return function () { document.removeEventListener('keydown', onKey); };
  }

  function onDrawerKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
    }
  }

  function setToggles(expanded) {
    qsa('[data-bp-cart-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!b.hasAttribute('aria-controls')) b.setAttribute('aria-controls', 'bp-cart-drawer');
    });
  }

  function isOpen() {
    var d = drawerRoot();
    return !!(d && d.classList.contains('is-open'));
  }

  function open(opener) {
    var d = drawerRoot();
    var panel = drawerPanel();
    if (!d || !panel) {
      window.location.href = routes().cart;
      return;
    }
    if (opener && opener.nodeType === 1) lastOpener = opener;
    else if (!isOpen()) lastOpener = document.activeElement;
    window.clearTimeout(closeTimer);
    if (isOpen()) { panel.focus(); return; }

    d.hidden = false;
    void d.offsetWidth; // allow the transition to run
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setToggles(true);

    if (typeof BP.trapFocus === 'function') {
      var r = BP.trapFocus(panel, panel);
      releaseTrap = typeof r === 'function' ? r : (typeof BP.releaseFocus === 'function' ? function () { BP.releaseFocus(); } : null);
    } else {
      releaseTrap = ownTrap(panel);
    }
    document.addEventListener('keydown', onDrawerKeydown);
    panel.focus();
    emit('bp:cart:open', {});
  }

  function close() {
    var d = drawerRoot();
    if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setToggles(false);
    document.removeEventListener('keydown', onDrawerKeydown);
    if (releaseTrap) { try { releaseTrap(); } catch (e) { /* ignore */ } releaseTrap = null; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = window.setTimeout(function () { if (!isOpen()) d.hidden = true; }, reduce ? 0 : 320);
    var target = lastOpener;
    lastOpener = null;
    if (target && document.contains(target) && typeof target.focus === 'function') target.focus();
    else {
      var t = qs('[data-bp-cart-toggle]');
      if (t) t.focus();
    }
    emit('bp:cart:close', {});
  }

  function toggleDrawer(opener) {
    if (isOpen()) close();
    else open(opener);
  }

  /* ---------- init ---------- */
  document.addEventListener('submit', onSubmit);
  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('keydown', onKeydownGlobal);

  // Keep everything in sync when the page is restored from bfcache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh().catch(function () {});
  });

  // Theme editor: reselecting the drawer section opens it for previewing.
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId === DRAWER_SECTION) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail && e.detail.sectionId === DRAWER_SECTION) close();
  });

  function init() { setToggles(false); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  BP.cart = {
    __ready: true,
    open: open,
    close: close,
    toggle: toggleDrawer,
    isOpen: isOpen,
    refresh: refresh,
    getCart: getCart,
    change: change,
    add: function (formOrData) {
      var fd = formOrData instanceof FormData ? formOrData : new FormData(formOrData);
      return add(fd).then(function (res) { open(); return res; });
    },
    formatMoney: formatMoney
  };
})();
